export default {
	get: {
		
	},
	post: {
		getList: '/dmall-manage/dmallmanage/order/orders',
		detail: '/dmall-manage/dmallmanage/order/detail',
		export: '/dmall-manage/dmallmanage/order/export'
  }
}